/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

export const GET_ACCOUNT = 'GET_ACCOUNT';
export const CHECK_AUTHENTICATION = 'CHECK_AUTHENTICATION';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export default {
  GET_ACCOUNT,
  CHECK_AUTHENTICATION,
  LOGIN,
  LOGOUT,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutation-types.js